import React from "react";
import { Row } from "reactstrap";
import Select from "react-select";
import { ColPrompt } from "./index";
import { ColValue, ErrorDiv } from "../ProductionModule/index";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
import _ from "lodash";
// Used on Hacoba NSA-HS Winder and Taining TN-09S S41 machines

export default function BackPressureSpringRow() {
   const { onChange, onChangeErrorDivDefinitions } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();
   const options = [
      { label: "---Select---", value: 0 },
      { label: ".81 mm Brown", value: 1 },
      { label: ".91 mm Green", value: 2 },
      { label: "1.00 mm White", value: 3 },
      { label: "1.10 mm Purple", value: 4 },
      { label: "1.20 mm Red", value: 5 },
      { label: "1.40 mm Yellow", value: 6 },
   ];

   return (
      <Row className="mb-2">
         <ColPrompt title={"Back Pressure Spring"} colorWhite={false} bold />
         <ColValue size={4}>
            <Select
               onChange={(e) => {
                  onChange("extendedPropertyJson.backPressureSpring", e.value);
                  if (e.value) {
                     onChangeErrorDivDefinitions("backPressureSpring", false);
                  } else {
                     onChangeErrorDivDefinitions("backPressureSpring", true);
                  }
               }}
               value={_.find(options, x => x.value === machineSetup.extendedPropertyJson.backPressureSpring) || options[0]}
               options={options}
               classNamePrefix="serviceThreadSelect"
            />
            {errorDivDefinitions?.backPressureSpring && (
               <ErrorDiv>Please Select an Option</ErrorDiv>
            )}
         </ColValue>
      </Row>
   );
}
